import script from "./contract.vue?vue&type=script&setup=true&lang=ts"
export * from "./contract.vue?vue&type=script&setup=true&lang=ts"

import "./contract.vue?vue&type=style&index=0&id=4c3bb3ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c3bb3ce"]])

export default __exports__